import React from 'react';
import cn from 'classnames';
import * as styles from './textincolumns.module.scss';

export function Component({ content, columnCount = 2, className }) {
  const style = { '--columnCount': columnCount };

  return (
    <div className={cn(className, styles.wrapper)} style={style}>
      {content.map((item, i) => {
        return (
          <p key={i} className={styles.text}>
            {item}
          </p>
        );
      })}
    </div>
  );
}
